import AppContext from '../../appContext'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import { getSiteSelectorUrls, Site } from '@dustin-web/microsite-config/src/site-context'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { getNames, getSourcingCompany } from 'src/helperFunctions'
import { useRouter } from 'next/router'
import { ServerEnvironment } from '@dustin-web/microsite-config/src/server-settings'

type ProviderProps = {
  children: React.ReactNode
  site: Site
  serverEnv: ServerEnvironment
  contactIdFromCookie?: number
  anonymousUserIdentifier?: string
}

const Provider = ({ children, site, serverEnv, contactIdFromCookie, anonymousUserIdentifier }: ProviderProps) => {
  const { sourcingCompany } = useSiteContext()
  const { userData, isAuthenticated, isLoading: isAuthLoading } = useAuth()

  const names = getNames(userData?.profile.name)
  const gqlSourcingCompany = getSourcingCompany(sourcingCompany)
  const router = useRouter()

  let returnUrl =
    router?.query.return_url ?? router?.query.returnUrl ?? router?.query.returnurl ?? null
  let preRegistrationToken = router?.query.preregistrationtoken ?? null

  try {
    returnUrl = !!returnUrl ? decodeURIComponent(returnUrl as string) : null
  } catch (err) {
    console.error('Could not decode returnurl', { err, returnUrl })

    returnUrl = null
  }
  preRegistrationToken = !!preRegistrationToken
    ? decodeURIComponent(preRegistrationToken as string)
    : null

  if (!returnUrl) {
    returnUrl = getSiteSelectorUrls(site, serverEnv)
  }

  if (isAuthLoading) {
    return null
  }

  return (
    <AppContext.Provider
      value={{
        sourcingCompany: gqlSourcingCompany,
        firstName: names.firstName,
        lastName: names.lastName,
        fullName: userData?.profile?.name ? userData.profile.name : '',
        email: userData?.profile?.email ? userData.profile.email : '',
        returnUrl,
        isAuthenticated,
        preRegistrationToken: preRegistrationToken,
        contactIdFromCookie,
        anonymousUserIdentifier
      }}>
      {children}
    </AppContext.Provider>
  )
}

export default Provider
